<template>
	<div class="dataentry">
		<VueLoading :active.sync="showLoadingIndicator" :can-cancel="true"></VueLoading>

		<div v-if="currentSportsType" class="dataentry__avatar">
			<div class="dataentry__avatar__mask">
				<img src="@/assets/profile_avatar_mask.svg" alt=""/>
			</div>
			<img :src="'https://app.sportlerplus.com/scaled/800/' + currentSportsType.image_url"/>
		</div>

		<div v-else-if="currentActivity && currentActivity.activity" class="card">
			<div class="card__title">{{ currentActivity.activity.title }}</div>
			<img class="card__image"
				:src="'https://app.sportlerplus.com/scaled/800/' + currentActivity.activity.image_url"/>
		</div>

		<h1 v-if="currentSportsType">Bist Du fertig?</h1>
		<p v-if="currentSportsType">Du kannst deine Daten manuell eintragen oder aus Health Connect oder Apple Health
			importieren.</p>

		<p v-else-if="currentActivity && currentActivity.activity && currentActivity.activity.description"
		v-html="showFullDescription ? currentActivity.activity.description : truncateDescription(currentActivity.activity.description, 3)"
			:class="{ 'expanded': showFullDescription, 'clamped': !isDescriptionClamped }"
			ref="descriptionText">
		</p>

		<div
			v-if="currentActivity && currentActivity.activity && currentActivity.activity.description && isDescriptionClamped"
			class="dataentry__moretext" @click="toggleDescription">
			Alles anzeigen
		</div>

		<!-- Button: Fitnessdaten importieren -->
		<v-btn @click="openTrackedWorkoutsModal" class="button button--outline button--small button--icon">
			<img src="@/assets/ic_16_share.svg" alt="">
			Fitnessdaten importieren
		</v-btn>

		<!-- Divider -->
		<div class="divider">
			oder
		</div>

		<!-- Inputfelder -->
		<div class="stepper__container">

			<!-- Import Hint -->
			<div class="stepper__hint" v-if="trackedWorkoutFrom > 0">
				<!-- TODO @Marco: Hier muss abhängig vom Datenlieferanten ein anderer Name stehen -->
				Von {{ getNameOfImportSource }} importiert
			</div>

			<!-- Zeit -->
			<div class="stepper">
				<div class="stepper__icon stepper__icon__down">
					<img v-on:click="changeDuration(-60)" src="@/assets/ic_32_stepper_down.svg" alt=""/>
				</div>
				<div class="stepper__value">
					<input v-if="this.trackedWorkoutFrom < 1" @click="selectText($event.target)"
						@blur="duration = parseTime($event.target.value) || 0" class="stepper__value" :value="
            displayTime + ' Min:Sek'" :class="duration > 0 ? '' : 'empty'">
					<input v-else @click="openChangeTrackedDataAlertModal" :value="displayTime + ' Min:Sek'"
					:class="duration > 0 ? '' : 'empty'">
				</div>
				<div class="stepper__icon stepper__icon__up">
					<img v-on:click="changeDuration(60)" src="@/assets/ic_32_stepper_up.svg" alt=""/>
				</div>
			</div>

			<!-- Distanz -->
			<div class="stepper">
				<div class="stepper__icon stepper__icon__down">
					<img v-on:click="changeDistance(-1)" src="@/assets/ic_32_stepper_down.svg" alt=""/>
				</div>
				<div class="stepper__value">
					<input v-if="this.trackedWorkoutFrom < 1" @click="selectText($event.target)"
						@blur="distance = formatData($event.target.value) || 0" class="stepper__value" :value="
            distance + ' km'" :class="distance > 0 ? '' : 'empty'">
					<input v-else @click="openChangeTrackedDataAlertModal" :value="distance + ' km'"
						:class="distance > 0 ? '' : 'empty'">
				</div>
				<div class="stepper__icon stepper__icon__up">
					<img v-on:click="changeDistance(1)" src="@/assets/ic_32_stepper_up.svg" alt=""/>
				</div>
			</div>

			<!-- Kalorien -->
			<div class="stepper">
				<div class="stepper__icon stepper__icon__down">
					<img v-on:click="changeEnergy(-1)" src="@/assets/ic_32_stepper_down.svg" alt=""/>
				</div>
				<div class="stepper__value">
					<input v-if="this.trackedWorkoutFrom < 1" @click="selectText($event.target)"
						@blur="energy = formatData($event.target.value) || 0" class="stepper__value" :value="
            displayEnergy + ' kcal'" :class="energy > 0 ? '' : 'empty'">
					<input v-else @click="openChangeTrackedDataAlertModal" :value="displayEnergy + ' kcal'"
						:class="energy > 0 ? '' : 'empty'">
				</div>
				<div class="stepper__icon stepper__icon__up">
					<img v-on:click="changeEnergy(1)" src="@/assets/ic_32_stepper_up.svg" alt=""/>
				</div>
			</div>

			<!-- Datum -->
			<div class="stepper">
				<div class="stepper__icon stepper__icon__down">
					<img v-on:click="previousDay()" src="@/assets/ic_32_stepper_down.svg" alt=""/>
				</div>
				<div class="stepper__value">
					<input v-if="this.trackedWorkoutFrom < 1" type="date" placeholder="tt.mm.jjjj"
					v-model="activityDate" class="has-value"
						onchange="this.className=(this.value!=''?'has-value':'')">
					<input v-else @click="openChangeTrackedDataAlertModal" type="date" placeholder="tt.mm.jjjj"
					v-model="activityDate" class="has-value">
				</div>
				<div class="stepper__icon stepper__icon__up">
					<img v-on:click="nextDay()" src="@/assets/ic_32_stepper_up.svg" alt=""/>
				</div>
			</div>

			<ChangeTrackedDataAlertModal :title="'Vorsicht!'"
				:message="'Möchtest du wirklich die importierten Daten ändern?'"
				:agreeText="'Ja, Daten ändern'" :disagreeText="'Daten nicht ändern'"
				@acceptChanges=allowChanges
				@closeChangeTrackedDataAlertModal=closeChangeTrackedDataAlertModal>>
			</ChangeTrackedDataAlertModal>
			<TrackedWorkoutsModal v-if="activityDate" :realStartDate="activityDate" @importWorkout="importWorkout"
														@closeTrackedWorkoutsModal=closeTrackedWorkoutsModal></TrackedWorkoutsModal>

		</div>

		<v-btn @click="completeFitnessPlanEvent" class="button button--primary">Training abschließen</v-btn>

	</div>
</template>
<script>

import moment from "moment";
import VueLoading from 'vue-loading-overlay/dist/vue-loading';
// Import stylesheet
import 'vue-loading-overlay/src/css/index.css';
import TrackedWorkoutsModal from "@/components/TrackedWorkoutsModal.vue";
import ChangeTrackedDataAlertModal from "@/components/ChangeTrackedDataAlertModal.vue";
import {analytics} from '@/firebase/index.js';
import {callNativeBridge} from '@/sportlerplus-helper';
import { getFitnessPlanEvent, updateEventStatus as apiUpdateEventStatus } from '@/services/fitnessPlanApi';

export default {
	name: 'FitnessPlanEditCustomActivity',
	components: {ChangeTrackedDataAlertModal, TrackedWorkoutsModal, VueLoading},
	data() {
		return {
			sportsTypes: [],
			currentSportsType: null,
			sportsTypeId: null,
			distance: 0,
			energy: 0,
			duration: 0,
			activityTime: "",
			activityDate: "",
			realStartDate: null,
			currentActivity: null,
			showLoadingIndicator: false,
			trackingData: null,
			// tracked from Apple HealthKit = 1, from GoogleFit = 2, not tracked = -1, manual changed tracking data = 0
			trackedWorkoutFrom: null,
			isDescriptionClamped: false,
			showFullDescription: false,
		}
	},
	computed: {
		displayTime() {
			if (this.duration) {
				let m = Math.floor(this.duration / 60);
				let s = Math.floor(this.duration % 60);
				if (s > 0 && s < 10) {
					return m + ":0" + s;
				} else if (s > 10) {
					return m + ":" + s;
				}
				return m + ":00";
			}
			return "0:00";
		},
		displayEnergy() {
			if (this.energy) {
				return Math.round(this.energy);
			}
			return 0;
		},
		getNameOfImportSource() {
			if (this.trackedWorkoutFrom === 1) {
				return "Apple HealthKit"
			} else {
				return "Health Connect"
			}
		},
	},
	methods: {
		init() {
			this.showLoadingIndicator = true;
			this.sportsTypeId = parseInt(this.$route.query.sportsType_id);
			this.fetchSportsTypes();
			this.loadFitnessPlanEvent().then(() => this.checkDescriptionClamp());
		},
		checkDescriptionClamp() {
			const elem = this.$refs.descriptionText;
			if (elem) {
				const isTextClamped = elem => elem.scrollHeight > elem.clientHeight;
				new ResizeObserver((e) => {
					this.isDescriptionClamped = isTextClamped(e[0].target);
				}).observe(elem);
			}
		},
		toggleDescription() {
			this.showFullDescription = !this.showFullDescription;
		},
		truncateDescription(description, lines) {
			if (description == null) {
				return "";
			}
			return description.split('\n').slice(0, lines).join('\n');
		},
		importWorkout(workout) {
			this.duration = workout.duration;
			// Convert meters to kilometers and get 2 decimal places
			this.distance = Math.round(workout.distance.value / 10) / 100;
			this.energy = workout.energy.value;
			// HealthKit start is display / realStart only — planned slot stays on currentActivity
			const fromDate = workout.from_utc.split(" ")[0];
			const fromTime = (workout.from_utc.split(" ")[1] || "").substring(0, 5);
			this.activityDate = moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
			this.activityTime = moment(fromTime, 'HH:mm').format('HH:mm');
			this.realStartDate = moment(fromDate + ' ' + fromTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
			this.trackedWorkoutFrom = workout.import_source;
		},
		openTrackedWorkoutsModal() {
			this.$modal.show("trackedWorkouts");
			analytics.logEvent('try_import_of_tracking_data');
		},
		closeTrackedWorkoutsModal() {
			this.$modal.hide("trackedWorkouts");
		},
		myParseFloat(f) {
			return parseFloat(f.replace(/,/, "."));
		},
		formatData(f) {
			return Math.round(this.myParseFloat(f) * 100) / 100;
		},
		parseTime(t) {
			let tc = t.split(":");
			if (tc.length == 2) {
				let minutes = parseInt(tc[0]);
				let seconds = parseInt(tc[1]);
				return minutes * 60 + seconds;
			}
			if (tc.length == 3) {
				let hours = parseInt(tc[0]);
				let minutes = parseInt(tc[1]);
				let seconds = parseInt(tc[2]);
				return hours * 3600 + minutes * 60 + seconds;
			} else {
				return parseInt(tc[0]) * 60;
			}
		},
		fetchSportsTypes() {
			this.$store.dispatch('fetchSportsTypes').then(() => {
				this.sportsTypes = this.$store.getters.getSportsTypes;
				this.currentSportsType = this.sportsTypes.find(st => st.id == this.sportsTypeId);
			});
		},
		changeDistance(val) {
			if (this.trackedWorkoutFrom < 1) {
				this.distance = Math.max(0, this.distance + val);
			} else {
				this.openChangeTrackedDataAlertModal();
			}
		},
		changeEnergy(val) {
			if (this.trackedWorkoutFrom < 1) {
				this.energy = Math.max(0, this.energy + val);
			} else {
				this.openChangeTrackedDataAlertModal();
			}
		},
		changeDuration(val) {
			if (this.trackedWorkoutFrom < 1) {
				this.duration = Math.max(0, this.duration + val);
			} else {
				this.openChangeTrackedDataAlertModal();
			}
		},
		previousDay() {
			if (this.trackedWorkoutFrom < 1) {
				this.activityDate = moment(this.activityDate).subtract(1, 'days').format('YYYY-MM-DD').toString();
			} else {
				this.openChangeTrackedDataAlertModal();
			}
		},
		nextDay() {
			if (this.trackedWorkoutFrom < 1) {
				this.activityDate = moment(this.activityDate).add(1, 'days').format('YYYY-MM-DD').toString();
			} else {
				this.openChangeTrackedDataAlertModal();
			}
		},
		openChangeTrackedDataAlertModal() {
			this.$modal.show("changeTrackedDataAlert");
		},
		closeChangeTrackedDataAlertModal() {
			this.$modal.hide("changeTrackedDataAlert");
		},
		allowChanges() {
			this.trackedWorkoutFrom = 0;
			this.$modal.hide("changeTrackedDataAlert");
		},
		async completeFitnessPlanEvent() {
			if (!this.currentActivity) {
				console.error('No current activity to complete');
				return;
			}

			this.showLoadingIndicator = true;

			// Lookup = planned calendar slot; UI date/time may be HealthKit actual start
			const plannedDate = this.currentActivity.activityDate;
			const plannedTime = this.currentActivity.activityTime;
			const actualDate = this.activityDate;
			const actualTime = this.activityTime;
			const shouldRelocate = this.trackedWorkoutFrom > 0 &&
				(actualDate !== plannedDate || actualTime !== plannedTime);
			
			try {
				console.log('Completing fitness plan event...', {
					guid: this.currentActivity.guid,
					activityDate: plannedDate,
					activityTime: plannedTime,
					realStartDate: actualDate + ' ' + actualTime,
					relocate: shouldRelocate
				});

				const userId = this.$store.state.user.user.uid;
				const eventInfo = {
					guid: this.currentActivity.guid,
					activityDate: plannedDate,
					activityTime: plannedTime,
					status: 'finished',
					activity: this.currentActivity.activity || {}
				};
				if (shouldRelocate) {
					eventInfo.relocateTo = {
						activityDate: actualDate,
						activityTime: actualTime
					};
				}

				const extraData = {
					realDuration: this.duration / 60,
					energyExpended: this.energy,
					distance: this.distance,
					_realStartDate: moment(actualDate + ' ' + actualTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm').toString()
				};

				if (!this.currentActivity.trackedWorkoutFrom || this.currentActivity.trackedWorkoutFrom < 1) {
					extraData.trackedWorkoutFrom = this.trackedWorkoutFrom;
					extraData._realDuration = this.currentActivity.realDuration || "0";
					extraData._energyExpended = this.currentActivity.energyExpended || "0";
					extraData._distance = this.currentActivity.distance || "0";
					extraData._activityState = this.currentActivity.activityState;
					
					if (!this.currentActivity._realStartDate && !this.currentActivity.realStartDate) {
						extraData._realStartDateOld = moment(plannedDate + ' ' + plannedTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm').toString();
					}
				}

				const result = await apiUpdateEventStatus(userId, eventInfo, extraData);
				console.log('Training successfully completed:', result);

				if (shouldRelocate) {
					this.currentActivity.activityDate = actualDate;
					this.currentActivity.activityTime = actualTime;
				}

				analytics.logEvent('complete_workout', { 
					activity_type: this.currentActivity.activity?.name || 'unknown',
					duration: this.duration / 60,
					energy: this.energy
				});

				this.$store.state.fitnessPlan = null;

				this.showLoadingIndicator = false;
				await this.$router.push("/fitnessplan?date=" + (shouldRelocate ? actualDate : plannedDate));
				this.increaseFinishedWorkoutsForReview();

			} catch (error) {
				console.error('Error completing training:', error);
				this.showLoadingIndicator = false;
				alert('Fehler beim Speichern der Trainingsdaten: ' + (error.message || 'Unbekannter Fehler'));
			}
		},
		increaseFinishedWorkoutsForReview() {
			callNativeBridge(
				'increaseFinishedWorkoutsHandler',
				{'increaseFinishedWorkouts': 1},
				'increaseFinishedWorkouts'
			);
		},
		selectText(elem) {
			elem.select();
		},
		async loadFitnessPlanEvent() {
			// Definiere eventInfo außerhalb des try-catch für besseren Scope
			const eventInfo = {
				guid: this.$route.query.guid,
				activityDate: this.$route.query.activityDate,
				activityTime: decodeURIComponent(this.$route.query.activityTime || ''), // URL-Decoding für 15%3A00 -> 15:00
			};
			
			try {

				if (!eventInfo.guid || !eventInfo.activityDate || !eventInfo.activityTime) {
					console.error('Missing required URL parameters for event loading');
					this.showLoadingIndicator = false;
					return;
				}

				console.log('Loading specific event from Cloud Function:', eventInfo);

				// OPTIMIERT: Cloud Function für spezifisches Event
				const userId = this.$store.state.user.user.uid;
				const data = await getFitnessPlanEvent(userId, {
					guid: eventInfo.guid,
					activityDate: eventInfo.activityDate,
					activityTime: eventInfo.activityTime,
				});
				console.log('Event loaded from Cloud Function:', data);

				this.currentActivity = data.event;

				// Setze UI-Werte basierend auf geladenen Daten
				if (data.event.hasStartedData) {
					// Event wurde bereits begonnen - lade vorhandene Daten
					this.distance = data.event.distance || 0;
					this.energy = data.event.energyExpended || 0;
					this.duration = Math.round((data.event.realDuration || 0) * 60);
					
					if (data.event.trackedWorkoutFrom) {
						this.trackedWorkoutFrom = data.event.trackedWorkoutFrom;
					}
					
					if (data.event.realStartDate) {
						this.activityDate = moment(data.event.realStartDate, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD').toString();
						this.activityTime = moment(data.event.realStartDate, 'YYYY-MM-DD HH:mm').format('HH:mm').toString();
						this.realStartDate = moment(data.event.realStartDate, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm').toString();
					} else {
						this.activityDate = moment(data.event.activityDate, 'YYYY-MM-DD').format('YYYY-MM-DD').toString();
						this.activityTime = moment(data.event.activityTime, 'HH:mm').format('HH:mm').toString();
						this.realStartDate = moment(data.event.activityDate + ' ' + data.event.activityTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm').toString();
					}
				} else {
					// Event wurde noch nicht begonnen - Standard-Werte
					this.distance = 0;
					this.energy = 0;
					this.duration = 0;
					this.trackedWorkoutFrom = 0;
					
					this.activityDate = moment(data.event.activityDate, 'YYYY-MM-DD').format('YYYY-MM-DD').toString();
					this.activityTime = moment(data.event.activityTime, 'HH:mm').format('HH:mm').toString();
					this.realStartDate = moment(data.event.activityDate + ' ' + data.event.activityTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm').toString();
				}

				this.showLoadingIndicator = false;

			} catch (error) {
				console.error('Error loading event:', error);
				this.showLoadingIndicator = false;
				
				// SAUBERE Fehlerbehandlung: Zurück zur Fitnessplan-Übersicht
				alert('Aktivität nicht gefunden. Bitte versuchen Sie es erneut.');
				this.$router.push('/fitnessplan');
			}
		},
	},
	mounted() {
		this.init();
	},
}
</script>

<style lang="scss">
.dataentry {
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	max-width: 480px;
	margin: 0px auto;

	&__header {
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin: 10px 0 40px;
	}

	&__avatar {
		position: relative;
		width: 104px;
		height: 118px;
		margin: 0px auto 19px;
		background: rgba($colorPrimary, .24);
		transform: scale(1.5);
		margin-top: 24px;
		margin-bottom: 50px;

		&:before {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			width: 24px;
			height: 4px;
			transform: translate(-50%, -50%);
			background: $colorPrimary;
		}

		&:after {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			width: 4px;
			height: 24px;
			transform: translate(-50%, -50%);
			background: $colorPrimary;
		}


		&__mask {
			position: absolute;
			z-index: 2;
			display: flex;
			pointer-events: none;
		}

		> img {
			position: relative;
			z-index: 1;
			width: calc(100% - 2px);
			height: calc(100% - 2px);
			margin: 1px;
			object-fit: cover;
		}
	}

	h1, p {
		color: $colorBlack;
		text-align: center;
		max-width: 480px;
		margin-left: auto;
		margin-right: auto;
	}

	h1 {
		margin-bottom: 7px;
	}

	p {
		margin-bottom: 37px;

		&:not(.expanded) {
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			overflow: hidden;
			max-height: 72px;
		}

		&.expanded {
			max-height: 100%;

			> p {
				max-height: 100%;
				display: inherit;
				-webkit-line-clamp: inherit;
				-webkit-box-orient: inherit;
				overflow: visible;
				max-height: inherit;
			}

			~ .dataentry__moretext {
				display: none;
			}
		}
	}

	&__moretext {
		position: relative;
		margin: -36px auto 32px;
		font-size: 14px;
		font-weight: 600;
		color: $colorBlack;
		cursor: pointer;
		padding: 8px 16px 8px 0;

		&:after {
			content: '';
			position: absolute;
			top: calc(50% - 6px);
			right: 0;
			width: 12px;
			height: 12px;
			background: url('../assets/ic_12_down.svg');
		}
	}

	input {
		&.empty {
			opacity: .24;
		}
	}

	.divider {
		margin: 7px 0 22px;
	}
}
</style>

<style lang="scss" scoped>
.button--outline {
	font-size: 17px;
	box-shadow: 0 0 0 1px rgba($colorBlack, .08), 0 8px 16px 0 rgba($colorBlack, .08);
}

.stepper__container {
	background: $colorWhite;
	border-radius: 12px;
	box-shadow: 0 0 0 1px rgba($colorBlack, .04), 0 8px 16px 0 rgba($colorBlack, .08);
	padding: 8px 0;
	margin-bottom: 32px;
	overflow: hidden;
}

.stepper__hint {
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba($colorPrimary, .08);
	box-shadow: 0 1px 0 0 $colorPrimary;
	font-size: 14px;
	line-height: 10px;
	font-weight: 700;
	color: $colorPrimary;
	margin-top: -8px;
	padding: 19px 0;
}

.stepper {
	padding: 16px;
	margin: 0;
}

.stepper__value {
	font-size: 17px;
}

input[type="date"] {
	min-height: inherit;
}
</style>